<template>
  <div v-if="renderQuestion(0)">
    <br>
    <div class="ui dividing sub header">
      PAM (Patient Activation Measure)
    </div>
    <div
      class="required field"
      v-if="renderQuestion(1)">
      <br>
      <label class="german">Letzten Endes bin ich derjenige, der dafür verantwortlich ist, für meine Gesundheit zu sorgen.</label>
      <label>When all is said and done, I am the person who is responsible for taking care of my health.</label>
      <select
        class="ui search fluid dropdown"
        id="pam-1">
        <option value="">
          How far do you agree with this statement?
        </option>
        <option value="1">
          <span class="german">Stimmt nicht</span> | Disagree strongly
        </option>
        <option value="2">
          <span class="german">Stimmt kaum</span> | Disagree
        </option>
        <option value="3">
          <span class="german">Stimmt eher</span> | Agree
        </option>
        <option value="4">
          <span class="german">Stimmt genau</span> | Agree strongly
        </option>
        <option value="5">
          <span class="german">nicht zutreffend</span> | N/A
        </option>
      </select>
    </div>

    <div
      class="required field"
      v-if="renderQuestion(2)">
      <br>
      <label class="german">Das Wichtigste für meine Gesundheit ist, eine aktive Rolle in meiner Gesundheitsversorgung zu übernehmen.</label>
      <label>Taking an active role in my own health care is the most important thing that affects my health.</label>
      <select
        class="ui search fluid dropdown"
        id="pam-2">
        <option value="">
          How far do you agree with this statement?
        </option>
        <option value="1">
          <span class="german">Stimmt nicht</span> | Disagree strongly
        </option>
        <option value="2">
          <span class="german">Stimmt kaum</span> | Disagree
        </option>
        <option value="3">
          <span class="german">Stimmt eher</span> | Agree
        </option>
        <option value="4">
          <span class="german">Stimmt genau</span> | Agree strongly
        </option>
        <option value="5">
          <span class="german">nicht zutreffend</span> | N/A
        </option>
      </select>
    </div>

    <div
      class="required field"
      v-if="renderQuestion(3)">
      <br>
      <label class="german">Ich weiss bei jedem meiner Medikamente, weshalb ich es nehme.</label>
      <label>I know what each of my prescribed medications do.</label>
      <select
        class="ui search fluid dropdown"
        id="pam-3">
        <option value="">
          How far do you agree with this statement?
        </option>
        <option value="1">
          <span class="german">Stimmt nicht</span> | Disagree strongly
        </option>
        <option value="2">
          <span class="german">Stimmt kaum</span> | Disagree
        </option>
        <option value="3">
          <span class="german">Stimmt eher</span> | Agree
        </option>
        <option value="4">
          <span class="german">Stimmt genau</span> | Agree strongly
        </option>
        <option value="5">
          <span class="german">nicht zutreffend</span> | N/A
        </option>
      </select>
    </div>

    <div
      class="required field"
      v-if="renderQuestion(4)">
      <br>
      <label class="german">Ich bin überzeugt, zu wissen, wann ich zum Arzt gehen muss und wann ich ein Gesundheitsproblem selbst behandeln kann.</label>
      <label>I am confident that I can tell whether I need to go to the doctor or whether I can take care of a health problem myself.</label>
      <select
        class="ui search fluid dropdown"
        id="pam-4">
        <option value="">
          How far do you agree with this statement?
        </option>
        <option value="1">
          <span class="german">Stimmt nicht</span> | Disagree strongly
        </option>
        <option value="2">
          <span class="german">Stimmt kaum</span> | Disagree
        </option>
        <option value="3">
          <span class="german">Stimmt eher</span> | Agree
        </option>
        <option value="4">
          <span class="german">Stimmt genau</span> | Agree strongly
        </option>
        <option value="5">
          <span class="german">nicht zutreffend</span> | N/A
        </option>
      </select>
    </div>

    <div
      class="required field"
      v-if="renderQuestion(5)">
      <br>
      <label class="german">Ich bin überzeugt, dass ich einem Arzt meine Sorgen mitteilen kann, auch wenn er mich nicht direkt darauf anspricht.</label>
      <label>I am confident that I can tell a doctor concerns I have even when he or she does not ask.</label>
      <select
        class="ui search fluid dropdown"
        id="pam-5">
        <option value="">
          How far do you agree with this statement?
        </option>
        <option value="1">
          <span class="german">Stimmt nicht</span> | Disagree strongly
        </option>
        <option value="2">
          <span class="german">Stimmt kaum</span> | Disagree
        </option>
        <option value="3">
          <span class="german">Stimmt eher</span> | Agree
        </option>
        <option value="4">
          <span class="german">Stimmt genau</span> | Agree strongly
        </option>
        <option value="5">
          <span class="german">nicht zutreffend</span> | N/A
        </option>
      </select>
    </div>

    <div
      class="required field"
      v-if="renderQuestion(6)">
      <br>
      <label class="german">Ich bin überzeugt, dass ich zu Hause notwendige medizinische Behandlungen selbst durchführen könnte.</label>
      <label>I am confident that I can follow through on medical treatments I may need to do at home.</label>
      <select
        class="ui search fluid dropdown"
        id="pam-6">
        <option value="">
          How far do you agree with this statement?
        </option>
        <option value="1">
          <span class="german">Stimmt nicht</span> | Disagree strongly
        </option>
        <option value="2">
          <span class="german">Stimmt kaum</span> | Disagree
        </option>
        <option value="3">
          <span class="german">Stimmt eher</span> | Agree
        </option>
        <option value="4">
          <span class="german">Stimmt genau</span> | Agree strongly
        </option>
        <option value="5">
          <span class="german">nicht zutreffend</span> | N/A
        </option>
      </select>
    </div>

    <div
      class="required field"
      v-if="renderQuestion(7)">
      <br>
      <label class="german">Ich war bisher in der Lage, Veränderungen meiner Lebensgewohnheiten – wie gesunde Ernährung und Bewegung - aufrechtzuerhalten.</label>
      <label>I have been able to maintain (keep up with) lifestyle changes, like eating right or exercising.</label>
      <select
        class="ui search fluid dropdown"
        id="pam-7">
        <option value="">
          How far do you agree with this statement?
        </option>
        <option value="1">
          <span class="german">Stimmt nicht</span> | Disagree strongly
        </option>
        <option value="2">
          <span class="german">Stimmt kaum</span> | Disagree
        </option>
        <option value="3">
          <span class="german">Stimmt eher</span> | Agree
        </option>
        <option value="4">
          <span class="german">Stimmt genau</span> | Agree strongly
        </option>
        <option value="5">
          <span class="german">nicht zutreffend</span> | N/A
        </option>
      </select>
    </div>

    <div
      class="required field"
      v-if="renderQuestion(8)">
      <br>
      <label class="german">Ich weiss, wie ich einer Verschlechterung meines Gesundheitszustandes vorbeugen kann.</label>
      <label>I know how to prevent problems with my health.</label>
      <select
        class="ui search fluid dropdown"
        id="pam-8">
        <option value="">
          How far do you agree with this statement?
        </option>
        <option value="1">
          <span class="german">Stimmt nicht</span> | Disagree strongly
        </option>
        <option value="2">
          <span class="german">Stimmt kaum</span> | Disagree
        </option>
        <option value="3">
          <span class="german">Stimmt eher</span> | Agree
        </option>
        <option value="4">
          <span class="german">Stimmt genau</span> | Agree strongly
        </option>
        <option value="5">
          <span class="german">nicht zutreffend</span> | N/A
        </option>
      </select>
    </div>

    <div
      class="required field"
      v-if="renderQuestion(9)">
      <br>
      <label class="german">Ich bin überzeugt, Lösungen zu finden, wenn sich mein Gesundheitszustand verschlechtert.</label>
      <label>I am confident I can figure out solutions when new problems arise with my health.</label>
      <select
        class="ui search fluid dropdown"
        id="pam-9">
        <option value="">
          How far do you agree with this statement?
        </option>
        <option value="1">
          <span class="german">Stimmt nicht</span> | Disagree strongly
        </option>
        <option value="2">
          <span class="german">Stimmt kaum</span> | Disagree
        </option>
        <option value="3">
          <span class="german">Stimmt eher</span> | Agree
        </option>
        <option value="4">
          <span class="german">Stimmt genau</span> | Agree strongly
        </option>
        <option value="5">
          <span class="german">nicht zutreffend</span> | N/A
        </option>
      </select>
    </div>

    <div
      class="required field"
      v-if="renderQuestion(10)">
      <br>
      <label class="german">Ich bin überzeugt, dass ich Veränderungen meiner Lebensgewohnheiten - wie Diät und körperliche Bewegung - auch in stressigen Zeiten fortführen kann.</label>
      <label>I am confident that I can maintain lifestyle changes, like eating right and exercising, even during times of stress.</label>
      <select
        class="ui search fluid dropdown"
        id="pam-10">
        <option value="">
          How far do you agree with this statement?
        </option>
        <option value="1">
          <span class="german">Stimmt nicht</span> | Disagree strongly
        </option>
        <option value="2">
          <span class="german">Stimmt kaum</span> | Disagree
        </option>
        <option value="3">
          <span class="german">Stimmt eher</span> | Agree
        </option>
        <option value="4">
          <span class="german">Stimmt genau</span> | Agree strongly
        </option>
        <option value="5">
          <span class="german">nicht zutreffend</span> | N/A
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  computed: {
    showableQuestions: function () {
      switch (this.$route.params.checkpoint) {
        case 'dayminus30':
          return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        case 'day0':
          return []
        case 'day90':
          return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        case 'day180':
          return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        case 'day270':
          return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        default:
          return []
      }
    }
  },
  methods: {
    renderQuestion: function (questionid) {
      if (this.showableQuestions.indexOf(parseInt(questionid)) > -1) {
        return true
      }
      return false
    }
  },
  mounted () {
    $('.ui.dropdown').dropdown()
  }
}
</script>

<style>

</style>
